// 2026-06-25: Operator clock-in/out service (Phase 1 of Epicor-like MES)
// Talks to NestJS Buddy backend at SERVER_URL2 (port 5000)
import axios from 'axios';

const BASE = `${window._env_.SERVER_URL2}api/clock`;

function ax() {
  return axios.create({ baseURL: BASE, timeout: 10000 });
}

export async function clockIn(payload) {
  // payload: { customer_id, operator_id, operator_name, operator_role?, machine_id?, machine_name?, shift_name?, activity?, wo_number?, op_seq?, source?, notes? }
  const r = await ax().post('/in', payload);
  return r.data;
}

export async function clockOut(payload) {
  // payload: { customer_id, operator_id, operator_name, notes?, activity_override? }
  const r = await ax().post('/out', payload);
  return r.data;
}

export async function getClockStatus(query) {
  // query: { customer_id, operator_id, operator_name }
  const r = await ax().get('/status', { params: query });
  return r.data;
}

export async function getLiveBoard(customer_id) {
  const r = await ax().get('/live-board', { params: { customer_id } });
  return r.data;
}

export async function getClockHistory(params) {
  // params: { customer_id, from?, to?, operator_id_filter?, machine_id?, limit? }
  const r = await ax().get('/history', { params });
  return r.data;
}

export async function getTodaySummary(customer_id) {
  const r = await ax().get('/today-summary', { params: { customer_id } });
  return r.data;
}
